// src/components/common/Confirm/ConfirmModalContainer.tsx
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import ConfirmModal from '@/components/molecules/ConfirmModal/ConfirmModal';
import { useAppDispatch } from '@/store';
import { useConfirm } from '@/hooks/useConfirm';
import { buildConfirmView } from '@/components/common/Confirm/confirmStrategies';
import type { RootState } from '@/store/rootReducer';

const ConfirmModalContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { confirm, close } = useConfirm();

  const currentAdminId = useSelector((state: RootState) => state.auth.user?.id ?? null);

  const ui = useMemo(() => {
    if (confirm === null) return null;
    return buildConfirmView(confirm, { dispatch, close, currentAdminId });
  }, [confirm, dispatch, close, currentAdminId]);

  if (confirm === null || ui === null) return null;

  return (
    <ConfirmModal
      open
      title={ui.title}
      paragraphs={ui.paragraphs}
      confirmText="Confirm"
      onClose={close}
      onConfirm={() => { void ui.onConfirm(); }}
    />
  );
};

export default ConfirmModalContainer;
